var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"id":"jp-en-button"},on:{"click":function($event){return _vm.$store.commit('toggleLang')}}},[_c('img',{attrs:{"id":"exit-button-img","src":require("@/assets/jp_en.png"),"alt":"JP_EN"}})])}
var staticRenderFns = []

export { render, staticRenderFns }